"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SpinnerIE = function SpinnerIE(_ref) {
  var props = _extends({}, _ref);

  var segments = [];

  for (var index = 0; index < 12; index++) {
    segments.push((0, _themeUi.jsx)("div", {
      sx: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        left: 0,
        top: 0,
        '&:before': {
          '@keyframes sk-circleFadeDelay': {
            '0%, 39%, 100%': {
              opacity: 0
            },
            '40%': {
              opacity: 1
            }
          },
          content: '""',
          display: 'block',
          margin: 'auto',
          width: '15%',
          height: '15%',
          bg: 'primary',
          borderRadius: '100%',
          animation: 'sk-circleFadeDelay 1.2s infinite ease-in-out both',
          animationDelay: (index - 11) / 10 + "s"
        },
        transform: "rotate(" + index * 30 + "deg)"
      }
    }));
  }

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      width: 4,
      height: 4,
      position: 'relative'
    }
  }), segments);
};

var Spinner = function Spinner(_ref2) {
  var ie = _ref2.ie,
      strokeWidth = _ref2.strokeWidth,
      props = _objectWithoutPropertiesLoose(_ref2, ["ie", "strokeWidth"]);

  return window.navigator.userAgent.match(/(MSIE|Trident)/) || ie ? (0, _themeUi.jsx)(SpinnerIE, null) : (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      height: 5,
      width: 5
    }
  }), (0, _themeUi.jsx)("svg", {
    viewBox: "25 25 50 50",
    sx: {
      position: 'relative',
      '@keyframes rotate360': {
        '100%': {
          transform: 'rotate(360deg)'
        }
      },
      animation: 'rotate360 2s linear infinite',
      height: 'inherit',
      width: 'inherit'
    }
  }, (0, _themeUi.jsx)("circle", {
    id: "spinnerCircle",
    cx: 50,
    cy: 50,
    r: 20,
    sx: {
      fill: 'none',
      height: '100%',
      width: '100%',
      strokeLinecap: 'round',
      strokeMiterlimit: 10,
      strokeDasharray: '1, 200',
      strokeDashoffset: 0,
      strokeWidth: strokeWidth,
      stroke: 'primary',
      '@keyframes dash': {
        '0%': {
          strokeDasharray: '1, 200',
          strokeDashoffset: '0'
        },
        '50%': {
          strokeDasharray: '90, 200',
          strokeDashoffset: '-35px'
        },
        '100%': {
          strokeDashoffset: '-125px'
        }
      },
      '@keyframes color': {
        '100%, 0%': {
          stroke: 'charts.data.0'
        },
        '40%': {
          stroke: 'charts.data.3'
        },
        '66%': {
          stroke: 'charts.data.7'
        },
        '80%, 90%': {
          stroke: 'charts.data.11'
        }
      },
      animation: 'dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite'
    }
  })));
};

Spinner.propTypes = {
  ie: _propTypes["default"].bool,
  strokeWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
Spinner.defaultProps = {
  ie: false,
  strokeWidth: 4
};
var _default = Spinner;
exports["default"] = _default;